import { render, staticRenderFns } from "./WelcomeText.vue?vue&type=template&id=06eff4d0&scoped=true"
import script from "./WelcomeText.vue?vue&type=script&lang=js"
export * from "./WelcomeText.vue?vue&type=script&lang=js"
import style0 from "./WelcomeText.vue?vue&type=style&index=0&id=06eff4d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eff4d0",
  null
  
)

export default component.exports